import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ListFeatures from '@adv-mt/mt-list-features'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {NEWS_DETAIL_EXTRA_INFO_BASE_CLASS} from '../config.js'

const PROS_AND_CONS_BASE_CLASS = `${NEWS_DETAIL_EXTRA_INFO_BASE_CLASS}ProsAndCons`

export const ProsAndConsSection = ({prosAndCons, layout}) => {
  const {i18n} = useContext(Context)

  if (!prosAndCons.length) return null

  return (
    <div className={PROS_AND_CONS_BASE_CLASS}>
      {prosAndCons.map((vehicleProsAndCons, index) => {
        const {pros, cons} = vehicleProsAndCons
        return (
          <>
            <div className={`${NEWS_DETAIL_EXTRA_INFO_BASE_CLASS}TitleWrapper`}>
              <TitleBasic
                title={i18n.t('NEWS.DETAIL_SECTION_PROS_AND_CONS', {
                  vehicleName: prosAndCons[index].vehicleName,
                  smart_count: prosAndCons.length
                })}
                as={titleBasicTags.h2}
                size={titleBasicSizes.s}
              />
            </div>
            <ListFeatures likes={pros} dislikes={cons} layout={layout} />
          </>
        )
      })}
    </div>
  )
}

ProsAndConsSection.propTypes = {
  prosAndCons: PropTypes.array,
  layout: PropTypes.oneOf(['horizontal', 'vertical'])
}
